"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackEvent = exports.trackPageView = undefined;
var _actionTypes = require("./actionTypes");
var trackPageView = exports.trackPageView = function trackPageView(data) {
  return {
    type: _actionTypes.TRACK_PAGEVIEW,
    data: data
  };
};
var trackEvent = exports.trackEvent = function trackEvent(eventName, data) {
  if (!eventName) {
    throw new TypeError("eventName is required.");
  }
  if (typeof eventName !== "string") {
    throw new TypeError("eventName must be of type string.");
  }
  return {
    type: _actionTypes.TRACK_EVENT,
    eventName: eventName,
    data: data
  };
};